export default "__VITE_ASSET__CYPaMtWX__"